import { render, staticRenderFns } from "./EditContactCRM.vue?vue&type=template&id=754b2524&scoped=true"
import script from "./EditContactCRM.vue?vue&type=script&lang=js"
export * from "./EditContactCRM.vue?vue&type=script&lang=js"
import style0 from "./edit-contact-crm.scss?vue&type=style&index=0&id=754b2524&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b2524",
  null
  
)

export default component.exports